<div
    class="collection-search-wrapper"
    *ngIf="collectionTitle"
    [ngStyle]="{ 'background-color': colors.mainColor }"
>
    <div class="container">
        <div class="collection-search" [ngClass]="{ 'action-disabled': disabled }">
            <div class="details">
                <app-link
                    *ngIf="!logo || windowSize.isMobile"
                    class="title selenium-collection-breadcrumb-title gtm-collection-breadcrumb-title"
                    [attr.data-gtmlabel]="collectionTitle"
                    [appRouterLink]="urlSegments"
                >
                    {{ collectionTitle }}
                </app-link>
                <app-link
                    *ngIf="logo && !windowSize.isMobile"
                    class="image selenium-collection-breadcrumb-image gtm-collection-breadcrumb-image"
                    [attr.data-gtmlabel]="collectionTitle"
                    [appRouterLink]="urlSegments"
                >
                    <img [src]="logo" alt="logo" />
                </app-link>
            </div>
            <div class="search-input-wrapper">
                <app-search-collection-input
                    [placeholder]="'Search ' + collectionTitle"
                    [disableAutocomplete]="true"
                    class="search-input"
                    [collection]="collectionSlug"
                ></app-search-collection-input>
            </div>
        </div>
    </div>
</div>
